import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import Price from '../../format/Price'

const Root = styled.div`
  ${({priceWidth}) => priceWidth
    ? css`
      width: ${priceWidth}px;
      text-align: right;
    ` : null
  }
  font-family: Merriweather, serif;
  font-size: ${({size}) => size === 'normal' ? '21px' : '16px'};
  line-height: 1.2;
  font-weight: 400;
  color: #2d9831;

  .priceBeforeDiscount {
    color: #757575;
    ${({size}) => size === 'normal'
      ? css`
        display: block;
        font-size: 14px;
      ` : css`
        display: block;
        font-size: 10px;
      `
    }
  }
  
  .decimal, .point {
    font-size: ${({size}) => size === 'normal' ? '12px' : '10px'};
  }
`

const GoodPrice = ({
  price,
  discount,
  currency,
  size = 'normal',
  priceWidth,
}) => {
  return <Root size={size} priceWidth={priceWidth}>
    <Price value={price} discount={discount} currency={currency} />
  </Root>
}

export default GoodPrice
